export const LIVE_ANNOUNCEMENT = '/announcement/liveAnnouncement'
